export const FEATURE_FLAGS = {
  showCalculators: false,
} as const;
